<template>
  <v-container-np>
    <HMVirtualTryOnCaseStudy></HMVirtualTryOnCaseStudy>
  </v-container-np>
</template>
